import { render, staticRenderFns } from "./TracksReleasesEditPanel.vue?vue&type=template&id=2f05d5bc"
import script from "./TracksReleasesEditPanel.vue?vue&type=script&lang=js"
export * from "./TracksReleasesEditPanel.vue?vue&type=script&lang=js"
import style0 from "./TracksReleasesEditPanel.vue?vue&type=style&index=0&id=2f05d5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports